// @ts-nocheck
export const localeCodes =  [
  "at",
  "bg",
  "ch",
  "cs",
  "da",
  "de",
  "en",
  "es",
  "fi",
  "fr",
  "fr-be",
  "gb",
  "hu",
  "ie",
  "it",
  "nl",
  "nl-be",
  "pl",
  "pt",
  "ro",
  "sk",
  "sv",
  "uk"
]
export const localeLoaders = {
  at: [
    {
      key: "locale_de_46json_a6e79afa",
      load: () => import("#nuxt-i18n/a6e79afa" /* webpackChunkName: "locale_de_46json_a6e79afa" */),
      cache: true
    },
    {
      key: "locale_de_46json_3e0ea50a",
      load: () => import("#nuxt-i18n/3e0ea50a" /* webpackChunkName: "locale_de_46json_3e0ea50a" */),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_bg_46json_471003cd",
      load: () => import("#nuxt-i18n/471003cd" /* webpackChunkName: "locale_bg_46json_471003cd" */),
      cache: true
    },
    {
      key: "locale_bg_46json_aaca624c",
      load: () => import("#nuxt-i18n/aaca624c" /* webpackChunkName: "locale_bg_46json_aaca624c" */),
      cache: true
    }
  ],
  ch: [
    {
      key: "locale_de_46json_a6e79afa",
      load: () => import("#nuxt-i18n/a6e79afa" /* webpackChunkName: "locale_de_46json_a6e79afa" */),
      cache: true
    },
    {
      key: "locale_de_46json_3e0ea50a",
      load: () => import("#nuxt-i18n/3e0ea50a" /* webpackChunkName: "locale_de_46json_3e0ea50a" */),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_27362e6b",
      load: () => import("#nuxt-i18n/27362e6b" /* webpackChunkName: "locale_cs_46json_27362e6b" */),
      cache: true
    },
    {
      key: "locale_cs_46json_a3157631",
      load: () => import("#nuxt-i18n/a3157631" /* webpackChunkName: "locale_cs_46json_a3157631" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_25ac4e7e",
      load: () => import("#nuxt-i18n/25ac4e7e" /* webpackChunkName: "locale_da_46json_25ac4e7e" */),
      cache: true
    },
    {
      key: "locale_da_46json_41881734",
      load: () => import("#nuxt-i18n/41881734" /* webpackChunkName: "locale_da_46json_41881734" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_a6e79afa",
      load: () => import("#nuxt-i18n/a6e79afa" /* webpackChunkName: "locale_de_46json_a6e79afa" */),
      cache: true
    },
    {
      key: "locale_de_46json_3e0ea50a",
      load: () => import("#nuxt-i18n/3e0ea50a" /* webpackChunkName: "locale_de_46json_3e0ea50a" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_322b2349",
      load: () => import("#nuxt-i18n/322b2349" /* webpackChunkName: "locale_en_46json_322b2349" */),
      cache: true
    },
    {
      key: "locale_en_46json_66102171",
      load: () => import("#nuxt-i18n/66102171" /* webpackChunkName: "locale_en_46json_66102171" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_2e1b76f1",
      load: () => import("#nuxt-i18n/2e1b76f1" /* webpackChunkName: "locale_es_46json_2e1b76f1" */),
      cache: true
    },
    {
      key: "locale_es_46json_1d1ff1c1",
      load: () => import("#nuxt-i18n/1d1ff1c1" /* webpackChunkName: "locale_es_46json_1d1ff1c1" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_25903c94",
      load: () => import("#nuxt-i18n/25903c94" /* webpackChunkName: "locale_fi_46json_25903c94" */),
      cache: true
    },
    {
      key: "locale_fi_46json_dc1e8a01",
      load: () => import("#nuxt-i18n/dc1e8a01" /* webpackChunkName: "locale_fi_46json_dc1e8a01" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_2502d1c2",
      load: () => import("#nuxt-i18n/2502d1c2" /* webpackChunkName: "locale_fr_46json_2502d1c2" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6c2ab992",
      load: () => import("#nuxt-i18n/6c2ab992" /* webpackChunkName: "locale_fr_46json_6c2ab992" */),
      cache: true
    }
  ],
  "fr-be": [
    {
      key: "locale_fr_46json_2502d1c2",
      load: () => import("#nuxt-i18n/2502d1c2" /* webpackChunkName: "locale_fr_46json_2502d1c2" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6c2ab992",
      load: () => import("#nuxt-i18n/6c2ab992" /* webpackChunkName: "locale_fr_46json_6c2ab992" */),
      cache: true
    }
  ],
  gb: [
    {
      key: "locale_en_46json_322b2349",
      load: () => import("#nuxt-i18n/322b2349" /* webpackChunkName: "locale_en_46json_322b2349" */),
      cache: true
    },
    {
      key: "locale_en_46json_66102171",
      load: () => import("#nuxt-i18n/66102171" /* webpackChunkName: "locale_en_46json_66102171" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_9198584c",
      load: () => import("#nuxt-i18n/9198584c" /* webpackChunkName: "locale_hu_46json_9198584c" */),
      cache: true
    },
    {
      key: "locale_hu_46json_d30160a4",
      load: () => import("#nuxt-i18n/d30160a4" /* webpackChunkName: "locale_hu_46json_d30160a4" */),
      cache: true
    }
  ],
  ie: [
    {
      key: "locale_en_46json_322b2349",
      load: () => import("#nuxt-i18n/322b2349" /* webpackChunkName: "locale_en_46json_322b2349" */),
      cache: true
    },
    {
      key: "locale_en_46json_66102171",
      load: () => import("#nuxt-i18n/66102171" /* webpackChunkName: "locale_en_46json_66102171" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_0e8d773e",
      load: () => import("#nuxt-i18n/0e8d773e" /* webpackChunkName: "locale_it_46json_0e8d773e" */),
      cache: true
    },
    {
      key: "locale_it_46json_16e8136a",
      load: () => import("#nuxt-i18n/16e8136a" /* webpackChunkName: "locale_it_46json_16e8136a" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_52380f5c",
      load: () => import("#nuxt-i18n/52380f5c" /* webpackChunkName: "locale_nl_46json_52380f5c" */),
      cache: true
    },
    {
      key: "locale_nl_46json_90d1fd0a",
      load: () => import("#nuxt-i18n/90d1fd0a" /* webpackChunkName: "locale_nl_46json_90d1fd0a" */),
      cache: true
    }
  ],
  "nl-be": [
    {
      key: "locale_nl_46json_52380f5c",
      load: () => import("#nuxt-i18n/52380f5c" /* webpackChunkName: "locale_nl_46json_52380f5c" */),
      cache: true
    },
    {
      key: "locale_nl_46json_90d1fd0a",
      load: () => import("#nuxt-i18n/90d1fd0a" /* webpackChunkName: "locale_nl_46json_90d1fd0a" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_fce412a0",
      load: () => import("#nuxt-i18n/fce412a0" /* webpackChunkName: "locale_pl_46json_fce412a0" */),
      cache: true
    },
    {
      key: "locale_pl_46json_a53212b8",
      load: () => import("#nuxt-i18n/a53212b8" /* webpackChunkName: "locale_pl_46json_a53212b8" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_45PT_46json_cbc0b9b2",
      load: () => import("#nuxt-i18n/cbc0b9b2" /* webpackChunkName: "locale_pt_45PT_46json_cbc0b9b2" */),
      cache: true
    },
    {
      key: "locale_pt_45PT_46json_6794941b",
      load: () => import("#nuxt-i18n/6794941b" /* webpackChunkName: "locale_pt_45PT_46json_6794941b" */),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_bfa891e6",
      load: () => import("#nuxt-i18n/bfa891e6" /* webpackChunkName: "locale_ro_46json_bfa891e6" */),
      cache: true
    },
    {
      key: "locale_ro_46json_de1968d7",
      load: () => import("#nuxt-i18n/de1968d7" /* webpackChunkName: "locale_ro_46json_de1968d7" */),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46json_bd155160",
      load: () => import("#nuxt-i18n/bd155160" /* webpackChunkName: "locale_sk_46json_bd155160" */),
      cache: true
    },
    {
      key: "locale_sk_46json_a38ab0b9",
      load: () => import("#nuxt-i18n/a38ab0b9" /* webpackChunkName: "locale_sk_46json_a38ab0b9" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_2cc1f3c6",
      load: () => import("#nuxt-i18n/2cc1f3c6" /* webpackChunkName: "locale_sv_46json_2cc1f3c6" */),
      cache: true
    },
    {
      key: "locale_sv_46json_94bece19",
      load: () => import("#nuxt-i18n/94bece19" /* webpackChunkName: "locale_sv_46json_94bece19" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_c888bfd0",
      load: () => import("#nuxt-i18n/c888bfd0" /* webpackChunkName: "locale_uk_46json_c888bfd0" */),
      cache: true
    },
    {
      key: "locale_uk_46json_1dbcf31e",
      load: () => import("#nuxt-i18n/1dbcf31e" /* webpackChunkName: "locale_uk_46json_1dbcf31e" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ebe6c25c" /* webpackChunkName: "config_i18n_46config_46ts_ebe6c25c" */)
]
export const normalizedLocales = [
  {
    code: "at",
    language: "de-AT",
    name: "Deutsch (Österreich)",
    dir: "ltr",
    country: "AT",
    currency: "EUR",
    flag: "circle-flags:at",
    borders: [
      "CZ",
      "DE",
      "HU",
      "IT",
      "LI",
      "SK",
      "SI",
      "CH"
    ]
  },
  {
    code: "bg",
    language: "bg-BG",
    name: "български",
    dir: "ltr",
    country: "BG",
    currency: "BGN",
    flag: "circle-flags:bg",
    borders: [
      "GR",
      "MK",
      "RO",
      "RS",
      "TR"
    ]
  },
  {
    code: "ch",
    language: "de-CH",
    name: "Deutsch (Schweiz)",
    dir: "ltr",
    country: "CH",
    currency: "CHF",
    flag: "circle-flags:ch",
    borders: [
      "AT",
      "FR",
      "IT",
      "LI",
      "DE"
    ]
  },
  {
    code: "cs",
    language: "cs-CZ",
    name: "Čeština",
    dir: "ltr",
    country: "CZ",
    currency: "CZK",
    flag: "circle-flags:cz",
    borders: [
      "AT",
      "DE",
      "PL",
      "SK"
    ]
  },
  {
    code: "da",
    language: "da-DK",
    name: "Dansk",
    dir: "ltr",
    country: "DK",
    currency: "DKK",
    flag: "circle-flags:dk",
    borders: [
      "DE"
    ]
  },
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch",
    dir: "ltr",
    country: "DE",
    currency: "EUR",
    flag: "circle-flags:de",
    borders: [
      "AT",
      "BE",
      "CZ",
      "DK",
      "FR",
      "LU",
      "NL",
      "PL",
      "CH"
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    dir: "ltr",
    country: "US",
    currency: "USD",
    flag: "circle-flags:us",
    borders: [
      "CA",
      "MX"
    ]
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español",
    dir: "ltr",
    country: "ES",
    currency: "EUR",
    flag: "circle-flags:es",
    borders: [
      "AD",
      "FR",
      "GI",
      "PT",
      "MA"
    ]
  },
  {
    code: "fi",
    language: "fi-FI",
    name: "Suomi",
    dir: "ltr",
    country: "FI",
    currency: "EUR",
    flag: "circle-flags:fi",
    borders: [
      "NO",
      "SE",
      "RU"
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    dir: "ltr",
    country: "FR",
    currency: "EUR",
    flag: "circle-flags:fr",
    borders: [
      "AD",
      "BE",
      "DE",
      "IT",
      "LU",
      "MC",
      "ES",
      "CH"
    ]
  },
  {
    code: "fr-be",
    language: "fr-BE",
    name: "Français (Belgique)",
    dir: "ltr",
    country: "BE",
    currency: "EUR",
    flag: "circle-flags:be",
    borders: [
      "FR",
      "DE",
      "LU",
      "NL"
    ]
  },
  {
    code: "gb",
    language: "en-GB",
    name: "English (UK)",
    dir: "ltr",
    country: "GB",
    currency: "GBP",
    flag: "circle-flags:gb",
    borders: [
      "IE"
    ]
  },
  {
    code: "hu",
    language: "hu-HU",
    name: "Magyar",
    dir: "ltr",
    country: "HU",
    currency: "HUF",
    flag: "circle-flags:hu",
    borders: [
      "AT",
      "HR",
      "RO",
      "RS",
      "SK",
      "SI",
      "UA"
    ]
  },
  {
    code: "ie",
    language: "en-IE",
    name: "English (Ireland)",
    dir: "ltr",
    country: "IE",
    currency: "EUR",
    flag: "circle-flags:ie",
    borders: [
      "GB"
    ]
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano",
    dir: "ltr",
    country: "IT",
    currency: "EUR",
    flag: "circle-flags:it",
    borders: [
      "AT",
      "FR",
      "SM",
      "SI",
      "CH",
      "VA"
    ]
  },
  {
    code: "nl",
    language: "nl-NL",
    name: "Nederlands",
    dir: "ltr",
    country: "NL",
    currency: "EUR",
    flag: "circle-flags:nl",
    borders: [
      "BE",
      "DE"
    ]
  },
  {
    code: "nl-be",
    language: "nl-BE",
    name: "Nederlands (België)",
    dir: "ltr",
    country: "BE",
    currency: "EUR",
    flag: "circle-flags:be",
    borders: [
      "FR",
      "DE",
      "LU",
      "NL"
    ]
  },
  {
    code: "pl",
    language: "pl-PL",
    name: "Polski",
    dir: "ltr",
    country: "PL",
    currency: "PLN",
    flag: "circle-flags:pl",
    borders: [
      "BY",
      "CZ",
      "DE",
      "LT",
      "RU",
      "SK",
      "UA"
    ]
  },
  {
    code: "pt",
    language: "pt-PT",
    name: "Português (Portugal)",
    dir: "ltr",
    country: "PT",
    currency: "EUR",
    flag: "circle-flags:pt",
    borders: [
      "ES"
    ]
  },
  {
    code: "ro",
    language: "ro-RO",
    name: "Română",
    dir: "ltr",
    country: "RO",
    currency: "RON",
    flag: "circle-flags:ro",
    borders: [
      "BG",
      "HU",
      "MD",
      "RS",
      "UA"
    ]
  },
  {
    code: "sk",
    language: "sk-SK",
    name: "Slovenčina",
    dir: "ltr",
    country: "SK",
    currency: "EUR",
    flag: "circle-flags:sk",
    borders: [
      "AT",
      "CZ",
      "HU",
      "PL",
      "UA"
    ]
  },
  {
    code: "sv",
    language: "sv-SE",
    name: "Svenska",
    dir: "ltr",
    country: "SE",
    currency: "SEK",
    flag: "circle-flags:se",
    borders: [
      "FI",
      "NO"
    ]
  },
  {
    code: "uk",
    language: "uk-UA",
    name: "Український",
    dir: "ltr",
    country: "UA",
    currency: "UAH",
    flag: "circle-flags:ua",
    borders: [
      "BY",
      "HU",
      "MD",
      "PL",
      "RO",
      "RU",
      "SK"
    ]
  }
]
/** client **/

/** client-end **/